import EnumService from '../../EnumService'

export default class StatusIndicadorEnumService extends EnumService{

    constructor(){
        super('enumStatusIndicador');
    }
  
}
